export var getItemId = function getItemId(idBase, index) {
  return "".concat(idBase, "-").concat(index);
};